<template>
<v-form ref="form" lazy-validation>
    <v-container grid-list-md @keyup.enter="nextTab">

        <v-layout wrap>
            <v-flex xs4>
                <v-select v-model="model.tipo_operacion" label="Tipo de Operación" :items="tiposOperacion" :clearable="true" hide-selected :rules="[rules.required]" item-value="clave" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs4>
                <v-select v-model="model.responsable_trafico" label="Responsable del Tráfico" :items="responsables" :clearable="true" hide-selected :rules="[rules.required]" item-value="email" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs4>
                <v-text-field label="Nombre Tráfico" v-model="model.nombre_trafico" :rules="[rules.required, validaNombreTrafico]" maxlength="75"></v-text-field>
            </v-flex>
            <v-flex xs3>
                <v-menu offset-x  v-model="calendarioEmbarque" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="model.fecha_embarque_field" label="Fecha de Embarque" v-mask="'##/##/####'" v-on="on" :rules="[rules.required, compareFecha]"></v-text-field>
                    </template>
                    <v-date-picker v-model="dateEmbarque" no-title @input="calendarioEmbarque = false" locale="es-mx"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs3>
                <v-menu offset-x  v-model="calendarioLlegada" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="model.fecha_llegada_field" label="Fecha Estimada de Llegada" v-mask="'##/##/####'" v-on="on" :rules="[rules.required, compareFecha]"></v-text-field>
                    </template>
                    <v-date-picker v-model="dateLlegada" no-title @input="calendarioLlegada = false" locale="es-mx"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs3>
                <v-select v-model="model.agente_aduanal" label="Agente Aduanal" :items="agentesAduanales" :rules="[rules.required]" item-value="id" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs3>
                <v-select v-model="model.representante_legal" label="Representante Legal" :items="representantes" :rules="[rules.required]" item-value="id" item-text="nombre"></v-select>
            </v-flex>



            <v-flex xs12>
                <v-subheader>
                    DATOS GENERALES
                </v-subheader>
            </v-flex>
            <v-flex xs4>
                <v-select v-model="model.aduana_despacho" label="Aduana de Despacho" :items="aduanasDespacho" :clearable="true" hide-selected item-value="id" :item-text="nombreAduanaSelect" :rules="[rules.required]"></v-select>
            </v-flex>
            <v-flex xs4>
                <v-select v-model="model.agente_carga" label="Agente de Carga o Reexpedidor" :items="agentesCarga" :clearable="true" hide-selected item-value="nombre" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs4>
                <v-text-field label="Referencia HBL" v-model="model.referencia_hbl"></v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-text-field label="BOOKING" v-model="model.booking"></v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-text-field label="Puerto de Embarque" v-model="model.puerto_embarque"></v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-select v-model="model.modalidad_transporte" label="Modalidad Transporte" :items="modalidadTransportes" :clearable="true" hide-selected item-value="nombre" item-text="nombre"></v-select>
            </v-flex>

            <v-flex xs3>
                <v-select v-model="model.tipo_embarque" label="Tipo de Embarque" :items="tiposEmbarque" :clearable="true" hide-selected item-value="clave" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs3>
                <v-select v-model="model.transportista_master" label="Transportista Intl Master" :items="transportistasMaster" :clearable="true" hide-selected item-value="nombre" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs3>
                <v-text-field label="Referencia Master" v-model="model.referencia_master"></v-text-field>
            </v-flex>
            <v-flex xs3>
                <v-select v-model="model.recinto_fiscal" label="Recinto Fiscal" :items="recintosFiscal" :clearable="true" hide-selected item-value="nombre" item-text="nombre"></v-select>
            </v-flex>

            <v-flex xs12>
                <v-subheader>
                    DATOS PEDIMENTO
                </v-subheader>
            </v-flex>
            <v-flex xs4>
                <v-text-field label="Número Pedimento" v-model="model.numero_pedimento" maxlength="20" :rules="[validaPatronPedimento]"></v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-text-field label="Clave Pedimento" v-model="model.clave_pedimento" @input="model.clave_pedimento = model.clave_pedimento.toUpperCase()" maxlength="2"></v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-menu offset-x  v-model="calendarioFechaPedimento" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field clearable v-model="model.fecha_pedimento_field" label="Fecha Pago pedimento" v-mask="'####-##-##'" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="datePedimento" no-title @input="calendarioFechaPedimento = false" locale="es-mx"></v-date-picker>
                </v-menu>
            </v-flex>            
        </v-layout>
    </v-container>

</v-form>
</template>

<script>
import axios from "axios";

export default {
    mounted: function () {
        this.model.fecha_embarque_field = this.formatDate(new Date().toISOString().substr(0, 10));
        this.model.fecha_llegada_field = this.formatDate(new Date().toISOString().substr(0, 10));
        this.fillSelects();
    },
    props: ['saveDatosGenerales'],
    data() {
        return {
            formUpdated: false,
            show_loading: true,
            id_cliente: '',
            calendarioEmbarque: false,
            calendarioLlegada: false,
            calendarioFechaPedimento: false,
            dateEmbarque: new Date().toISOString().substr(0, 10),
            dateLlegada: new Date().toISOString().substr(0, 10),
            datePedimento: '',
            tiposOperacion: [],
            responsables: [],
            agentesAduanales: [],
            representantes: [],
            agentesCarga: [],
            aduanasDespacho: [],
            modalidadTransportes: [],
            tiposEmbarque: [],
            transportistasMaster: [],
            recintosFiscal: [],
            selects: [{
                    'key': 'agente_aduanal',
                    'data': 'agentesAduanales',
                    'type': 'integer'
                },
                {
                    'key': 'representante_legal',
                    'data': 'representantes',
                    'type': 'integer'
                },
                {
                    'key': 'aduana_despacho',
                    'data': 'aduanasDespacho',
                    'type': 'string'
                }
            ],
            model: {
                tipo_operacion: '',
                responsable_trafico: '',
                nombre_trafico: '',
                referencia: '',
                fecha_embarque: '',
                fecha_llegada: '',
                fecha_embarque_field: '',
                fecha_llegada_field: '',
                agente_aduanal: '',
                representante_legal: '',
                numero_pedimento:'',
                fecha_pedimento: '',
                fecha_pedimento_field: '',
                clave_pedimento: '',

                agente_carga: '',
                referencia_hbl: '',
                booking: '',
                puerto_embarque: '',
                aduana_despacho: '',
                modalidad_transporte: '',
                tipo_embarque: '',
                transportista_master: '',
                referencia_master: '',
                recinto_fiscal: '',

            },
            rules: {
                required: v => !!v || 'Este campo es requerido',
            },
        }
    },
    watch: {
        dateEmbarque(val) {
            this.model.fecha_embarque_field = this.formatDate(val);
        },
        dateLlegada(val) {
            this.model.fecha_llegada_field = this.formatDate(val);
        },
        datePedimento(val){
            this.model.fecha_pedimento_field = this.formatDate(val);
        }
    },
    methods: {
        nextTab() {
            this.$emit('nextTab', 1);
        },
        validaNombreTrafico: function(){
            //JEMM - (21-01-2020): Lourdes solicitó este cambio en reunión en Ags el 10-01-2020
            if (this.model.nombre_trafico != ""){
                const pattern = /^[-_A-Za-z0-9]+$/;
                return pattern.test(this.model.nombre_trafico) || "Sólo se permiten números, letras, guiones medio y bajo";            
            }
            return true;
        },
        validaPatronPedimento(){
            if (this.model.numero_pedimento != ""){
                const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
                return patternPedimento.test(this.model.numero_pedimento) || "Número no válido. Ejemplo: 240-0123-0000123";
            }
            return true;
        },
        compareFecha() {
            if (this.model.fecha_embarque_field != '' && this.model.fecha_llegada_field != '') {
                let [day, month, year] = this.model.fecha_embarque_field.split('/')
                let fecha_embarque = new Date(year, month, day);

                [day, month, year] = this.model.fecha_llegada_field.split('/')
                let fecha_llegada = new Date(year, month, day);

                if (fecha_embarque <= fecha_llegada)
                    return true;
                else
                    return 'La fecha de embarque no puede ser posterior a la fecha de llegada'

            } else
                return true;
        },
        nombreAduanaSelect: function (aduana) {
            return aduana.id + ' - ' + aduana.nombre;
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`;
        },
        invertDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')

            return `${year}-${month}-${day}`;
        },
        convertData() {

            this.model.fecha_embarque = this.invertDate(this.model.fecha_embarque_field) + ' 00:00:01';
            this.model.fecha_llegada = this.invertDate(this.model.fecha_llegada_field) + ' 00:00:01';
            if (this.model.fecha_pedimento_field != null && this.model.fecha_pedimento_field != '')
                this.model.fecha_pedimento = this.invertDate(this.model.fecha_pedimento_field) + ' 00:00:01';
            else
                this.model.fecha_pedimento = null;

            for (var i = 0; i < this.selects.length; i++) {
                this.getJsonObject(this.selects[i].key, this.selects[i].data);
            }

        },
        invertData() {

            this.model.fecha_embarque_field = this.formatDate(this.model.fecha_embarque.substr(0, 10));
            this.model.fecha_llegada_field = this.formatDate(this.model.fecha_llegada.substr(0, 10));
            if (this.model.fecha_pedimento != null && this.model.fecha_pedimento!='')
                this.model.fecha_pedimento_field = this.formatDate(this.model.fecha_pedimento.substr(0, 10));

            for (var i = 0; i < this.selects.length; i++)
                this.getValueObject(this.selects[i].key, this.selects[i].type);
        },
        getJsonObject(param, data) {            
            if (this.model[param] == undefined || this.model[param] == '') {
                this.model[param] = '';
                return;
            }

            let clave = this.model[param];
            var nombre = "";
            
            if (this[data].length == 0)
                return;
            
            let filtro = this[data].filter(obj => obj.id == clave);
            
            if (filtro.length > 0) {            
                nombre = filtro[0].nombre;
            } else {                
                return;
            }
            
            this.model[param] = {
                "nombre": nombre,
                "clave": clave
            }
        },
        getValueObject(param, type) {
            if (this.model[param] == undefined || this.model[param] == '') {
                this.model[param] = '';
                return;
            }

            let clave = '';

            if (type == 'integer')
                clave = parseInt(this.model[param].clave);
            else
                clave = this.model[param].clave;

            this.model[param] = clave
        },
        save(resolve) {
            try {
                if (this.$refs.form.validate()) {
                    if (this.formUpdated == true) {
                        this.$root.$dialogLoader.show('Espere un momento por favor..');
                        this.convertData();
                        this.model.referencia = '';
                        this.model.usuario = this.$local_storage.get("nombre_usuario");                        

                        axios
                            .post(this.$hostname + "traficos/", this.model)
                            .then(response => {
                                this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El tráfico se creó correctamente.",
                                    footer: ""
                                });

                                this.model.referencia = response.data;
                                this.$local_storage.set('referencia', this.model.referencia);

                                this.invertData();
                                this.formUpdated = false;
                                this.$root.$dialogLoader.hide();
                                resolve(true);
                            }).catch(error => {
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: 'Ocurrió un error al guardar el tráfico.',
                                    footer: ""
                                });
                                console.log(error);
                                this.invertData();
                                this.$root.$dialogLoader.hide();
                                resolve(false);
                            });
                    } else {
                        resolve(true);
                    }

                } else {

                    this.$swal({
                        type: "info",
                        title: "Cuidado",
                        text: "Datos incompletos en el formulario. Favor de verificar.",
                        footer: ""
                    });

                    resolve(false);
                }
            } catch (error) {
                console.log(error);
            }
            
        },
        load() {
            this.model.referencia = this.$local_storage.get("referencia");;
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            let data = {
                rfc: this.model.rfc,
                referencia: this.model.referencia,
            };

            axios
                .post(this.$hostname + "traficos/obtener/", data, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {

                    for (let key in this.model) {
                        this.model[key] = response.data[key];
                    }

                    this.$local_storage.set('response_trafico', response.data);
                    this.invertData();

                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener el tráfico',
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                    this.formUpdated = false;
                });

        },
        update(resolve) {
            if (this.$refs.form.validate()) {
                if (this.formUpdated == true) {
                    this.$root.$dialogLoader.show('Espere un momento por favor..');
                    this.convertData();
                    axios
                        .put(this.$hostname + "traficos/actualizar/", this.model, {
                            "Content-type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "cache-control": "no-cache"
                        })
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El tráfico se actualizó correctamente.",
                                footer: ""
                            });
                            this.invertData();
                            this.formUpdated = false;
                            this.$root.$dialogLoader.hide();
                            resolve(true);

                        }).catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: 'Ocurrió un error al actualizar el tráfico',
                                footer: ""
                            });
                            this.$root.$dialogLoader.hide();
                            this.invertData();
                            resolve(false);
                        });
                } else {
                    resolve(true);
                }

            } else {
                this.$swal({
                    type: "info",
                    title: "Cuidado",
                    text: "Datos incompletos en el formulario. Favor de verificar.",
                    footer: ""
                });

                resolve(false);
            }
        },
        fillSelects() {

            // responsables
            axios.post(this.$hostname + "usuarios/obtener_usuarios_cliente/", {
                    'cliente': this.id_cliente,
                    'sistema': this.$sistema
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        var nombreResponsable = response.data[i].nombre + ' ' + (response.data[i].apellidos != undefined ? response.data[i].apellidos : '');
                        if(response.data[i].estatus)
                            datos.push({
                                'email': response.data[i].email,
                                'nombre': nombreResponsable.toString().trim(),
                            });
                    }
                    
                    this.responsables = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los responsables',
                        footer: ""
                    });
                });

            // representantes
            axios.post(this.$hostname + "catalogos/representantes/get_representantes/", {
                    "cliente": this.id_cliente})
                .then(response => {
                    let datos = [];
                    //this.agentesAduanales = response.data;
                    //console.log(this.agentesAduanales);

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'id': response.data[i].id_representante_legal,
                            'nombre': response.data[i].metadato,
                        });
                    }
                    this.representantes = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los representantes legales',
                        footer: ""
                    });
                });

            // agentesAduanales
            axios.post(this.$hostname + "catalogos/agentes_aduanales/get_agentes/", {
                    "cliente": this.id_cliente})
                .then(response => {
                    let datos = [];
                    //this.agentesAduanales = response.data;
                    //console.log(this.agentesAduanales);

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'id': response.data[i].id_agente_aduanual,
                            'nombre': response.data[i].metadato,
                        });
                    }
                    this.agentesAduanales = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los agentes de aduanales',
                        footer: ""
                    });
                });

            // aduanasDespacho
            axios.get(this.$hostname + "catalogos/aduanas/", {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'id': response.data[i].clave,
                            'nombre': response.data[i].nombre,
                        });
                    }

                    this.aduanasDespacho = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener las aduanas',
                        footer: ""
                    });
                });

            // agentesCarga
            axios.post(this.$hostname + "catalogos/agentes_carga/get_agentes_carga/", {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'id': response.data[i].id_agente_de_carga,
                            'nombre': response.data[i].metadato,
                        });
                    }

                    this.agentesCarga = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los agentes de carga',
                        footer: ""
                    });
                });

            // modalidadTransportes
            axios.post(this.$hostname + "apendices/lista/", {
                    "tabla": 1
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'id': response.data[i].id,
                            'nombre': response.data[i].descripcion,
                        });
                    }

                    this.modalidadTransportes = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los tipos de transporte',
                        footer: ""
                    });
                });

            // transportistasMaster
            axios.post(this.$hostname + "catalogos/transportistas/get_transportistas/", {
                    "cliente": this.id_cliente
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'id': response.data[i].id_transportista,
                            'nombre': response.data[i].metadato,
                        });
                    }

                    this.transportistasMaster = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los transportistas',
                        footer: ""
                    });
                });

            // recintosFiscal
            axios.post(this.$hostname + "apendices/lista/", {
                    "tabla": 18
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'id': response.data[i].id,
                            'nombre': response.data[i].descripcion,
                        });
                    }

                    this.recintosFiscal = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los recintos fiscales',
                        footer: ""
                    });
                });

            // tiposEmbarque
            axios.post(this.$hostname + "apendices/lista/", {
                    "tabla": 20
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'clave': response.data[i].clave,
                            'nombre': response.data[i].descripcion,
                        });
                    }

                    this.tiposEmbarque = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los tipos de embarque',
                        footer: ""
                    });
                });

            // tiposOperacion
            axios.post(this.$hostname + "apendices/lista/", {
                    "tabla": 21
                }, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(response => {
                    let datos = [];

                    for (var i = 0; i < response.data.length; i++) {
                        datos.push({
                            'clave': response.data[i].clave,
                            'nombre': response.data[i].descripcion,
                        });
                    }
                    this.$root.$dialogLoader.hide();
                    this.tiposOperacion = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los tipos de Operación',
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });

        },
        formChanged: function (newV, oldV) {
            this.formUpdated = true;
        }
    },
    created: function () {
        this.id_cliente = this.$local_storage.get("id_cliente");
        //this.id_cliente = 51;
        this.model.rfc = this.$local_storage.get("rfc");
        //this.model.rfc = 'MOLG9106088U1';
        if (this.$local_storage.get("update") == 'true')
            this.load();
        this.formUpdated = false;
        this.$watch('model', this.formChanged, {
            deep: true
        });
    },
    beforeDestroy: function () {
        this.model = "";
    },
}
</script>
